var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-header',[_c('nav-bar')],1),_c('el-container',[_c('el-aside',{attrs:{"width":_vm.asideWidth}},[_c('side-bar',{staticClass:"sidebar-container"})],1),_c('el-main',[_c('tags-view'),_c('app-main')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }